import type { HormoneProfile } from "../profile";
import { ProjectionChart } from "./ProjectionChart";

/**
 * Structure copies manly/report/ProjectionPage.tsx exactly: kicker, heading,
 * one lead paragraph, the chart card (compact 3-column head + chart), plain
 * CTA. The Berkeley 72-hour measurement lives in the lead so the page keeps
 * its one cited, verifiable number without the old milestone-card stack.
 */
export function ProjectionPage({
  profile, onNext,
}: { profile: HormoneProfile; onNext: () => void }) {
  return (
    <>
      <div className="qk-manly-kicker">Projected result</div>
      <h2>Where his daily load is headed.</h2>
      <p>
        Based on his answers, here is how fast the daily load drops once the fragrance carrier is
        out of the shower. Not a promise, a measurement: when UC Berkeley switched teenagers onto
        products free of these chemicals, the phthalate that carries scent was down 27 percent in
        72 hours.
      </p>

      <div className="qk-manly-chartcard">
        <div className="qk-manly-chart-head">
          <div className="qk-manly-chart-cell">
            <div className="qk-manly-eyebrow">Status</div>
            <div className="qk-manly-val">{profile.exposure}</div>
          </div>
          <div className="qk-manly-chart-cell">
            <div className="qk-manly-eyebrow">First drop</div>
            <div className="qk-manly-val is-accent">72 HRS</div>
          </div>
          <div className="qk-manly-chart-cell">
            <div className="qk-manly-eyebrow">His reset</div>
            <div className="qk-manly-val">WEEK 2</div>
          </div>
        </div>
        <ProjectionChart band={profile.exposure} />
      </div>

      {/* Pinned (client request): every funnel-page CTA in this quiz stays in
          view, unlike the sibling's plain projection CTA. */}
      <button type="button" className="qk-cta qk-manly-cta-sticky" onClick={onNext}>
        See what to swap
      </button>
    </>
  );
}
